import React from 'react';
import clsx from 'clsx';
import { ShippingLabelCarrier } from '@interfaces/models/timeline';
import styles from './select-carrier-options.module.scss';

interface CarrierNameProps {
  carrier: ShippingLabelCarrier;
  isSelected?: boolean;
}

const CarrierName = ({ carrier, isSelected }: CarrierNameProps) => {
  const { logo, name } = carrier || {};

  return (
    <div className={styles.carrierName}>
      <img
        className={styles.carrierName_logo}
        src={logo}
        alt={name}
      />
      <div
        className={clsx(styles.carrierName_name, {
          [styles.carrierName_nameBold]: isSelected,
        })}
      >
        {name}
      </div>
    </div>
  );
};

export default CarrierName;
